import { Controller } from "stimulus";

export default class extends Controller {

  openDynamicModal(event){
    event.preventDefault();

    var modalTarget = $(event.target).data('modalTarget');
    var modal = $(modalTarget);
    var modalUrl = $(event.target).data('modalUrl');

    console.log(event.target)
    console.log(modalTarget)
    console.log(modalUrl)
    modal.modal();
    modal.find('.modal-dialog-loaded').hide();
    modal.find('.modal-dialog-loading').show();


    fetch(modalUrl)
      .then(response => response.text())
      .then(function(html){
        modal.find('.modal-dialog-loaded').html(html);
        modal.find('.modal-dialog-loading').hide();
        modal.find('.modal-dialog-loaded').show();

        $('[data-toggle="tooltip"]').tooltip();
      });
  }

}